import youtube_icon from '../assets/images/youtube-icon.svg';
import blog_icon from '../assets/images/blog-icon.svg';
import star_line from '../assets/images/star-line.svg';
import down_arrow from '../assets/images/Down_Arrow_5.svg'; //
import checked1 from '../assets/images/checked1.svg'; //
import subject_img1 from '../assets/images/subject-img1.svg';
import subject_img2 from '../assets/images/subject-img2.svg';
import subject_img3 from '../assets/images/subject-img3.svg';
import short1 from '../assets/images/short1.svg';
import short2 from '../assets/images/short2.svg';
import short3 from '../assets/images/short3.svg';
import light from '../assets/images/light.svg';
import learning from '../assets/images/learning.svg';
import book from '../assets/images/book.svg';
import event_img1 from '../assets/images/event-img1.svg';
import event_img2 from '../assets/images/event-img2.svg';
import update_left from '../assets/images/update-left.svg';
import update_right from '../assets/images/update-right.svg';
import service_call from '../assets/images/service-call.svg';
import top_close from '../assets/images/top_close.svg';
import menu_line from '../assets/images/menu-line.svg';
import pause from '../assets/images/pause.svg';
import play from '../assets/images/play.svg';
import quick_login from '../assets/images/quick-login.svg';
import quick_logout from '../assets/images/quick-logout.svg';
import quick_myclass from '../assets/images/quick-myclass.svg';
import quick_mybook from '../assets/images/quick-mybook.svg';
import quick_classbook from '../assets/images/quick-classbook.svg';
import quick_up from '../assets/images/quick-up.svg';
import quick_chat from '../assets/images/quick-chat.svg';
import quick_myclass_white from '../assets/images/quick-myclass-white.svg';
import quick_mybook_white from '../assets/images/quick-mybook-white.svg';
import quick_classbook_white from '../assets/images/quick-classbook-white.svg';
import quick_up_white from '../assets/images/quick-up-white.svg';
import quick_chat_white from '../assets/images/quick-chat-white.svg';
import arrow_right_white from '../assets/images/arrow-right-white.svg';
import arrow_left_white from '../assets/images/arrow-left-white.svg';
import x_icon_white from '../assets/images/x-icon-white.svg';
import check_navy from '../assets/images/check-navy.svg';
import move_top_arrow from '../assets/images/move-top-arrow.svg';
import service_btn_right from '../assets/images/service-btn-right.svg';
import test_book from '../assets/images/test-book.svg';
import input_check from '../assets/images/input_check.svg';
import input_view from '../assets/images/pw_view_on.svg';
import input_view_off from '../assets/images/pw_view_off.svg';
import logo1 from '../assets/icon/partner_logo1.svg';
import logo2 from '../assets/icon/partner_logo2.svg';
import logo3 from '../assets/icon/partner_logo3.svg';
import logo4 from '../assets/icon/partner_logo4.svg';
import logo5 from '../assets/icon/partner_logo5.svg';
import logo6 from '../assets/icon/partner_logo6.svg';
import logo7 from '../assets/icon/partner_logo7.svg';
import logo8 from '../assets/icon/partner_logo8.svg';
import logo9 from '../assets/icon/partner_logo9.svg';
import logo10 from '../assets/icon/partner_logo10.svg';
import logo11 from '../assets/icon/partner_logo11.svg';
import logo12 from '../assets/icon/partner_logo12.svg';
import logo13 from '../assets/icon/partner_logo13.svg';
import logo14 from '../assets/icon/partner_logo14.svg';
import logo15 from '../assets/icon/partner_logo15.svg';
import option_chk from '../assets/icon/option_check.svg';
import test_img1 from "../assets/test_img1.svg";
import test_img2 from "../assets/test_img2.svg";
import test_img3 from "../assets/test_img3.svg";
import test_img4 from "../assets/test_img4.svg";
import test_img5 from "../assets/test_img5.svg";
import library_list1_img1 from "../assets/images/library_list1_img1.png";
import library_list1_img2 from "../assets/images/library_list1_img2.png";
import library_list1_img3 from "../assets/images/library_list1_img3.png";
import library_list1_img4 from "../assets/images/library_list1_img4.png";
import library_list1_img5 from "../assets/images/library_list1_img5.png";
import library_list2_img1 from "../assets/images/library_list2_img1.png";
import library_list2_img2 from "../assets/images/library_list2_img2.png";
import library_list2_img3 from "../assets/images/library_list2_img3.png";
import library_list2_img4 from "../assets/images/library_list2_img4.png";
import library_list2_img5 from "../assets/images/library_list2_img5.png";
import library_list3_img1 from "../assets/images/library_list3_img1.png";
import library_list3_img2 from "../assets/images/library_list3_img2.png";
import library_list3_img3 from "../assets/images/library_list3_img3.png";
import library_list3_img4 from "../assets/images/library_list3_img4.png";
import library_list3_img5 from "../assets/images/library_list3_img5.png";
import library_list4_img1 from "../assets/images/library_list4_img1.png";
import library_list4_img2 from "../assets/images/library_list4_img2.png";
import library_list4_img3 from "../assets/images/library_list4_img3.png";
import library_list4_img4 from "../assets/images/library_list4_img4.png";
import library_list4_img5 from "../assets/images/library_list4_img5.png";
import header_game_dev_img1 from "../assets/images/header_game_dev_img1.png";
import header_game_dev_img2 from "../assets/images/header_game_dev_img2.png";
import header_game_dev_img3 from "../assets/images/header_game_dev_img3.png";
import header_game_dev_img4 from "../assets/images/header_game_dev_img4.png";
import header_game_dev_img5 from "../assets/images/header_game_dev_img5.png";
import header_game_dev_img6 from "../assets/images/header_game_dev_img6.png";
import header_game_dev_img7 from "../assets/images/header_game_dev_img7.png";
import header_metaverse_img1 from "../assets/images/header_metaverse_img1.png";
import header_metaverse_img2 from "../assets/images/header_metaverse_img2.png";
import header_metaverse_img3 from "../assets/images/header_metaverse_img3.png";
import header_metaverse_img5 from "../assets/images/header_metaverse_img5.png";


import gm_01 from '../assets/images/gm_01.jpg';
import gm_02 from '../assets/images/gm_02.png';
import gm_03 from '../assets/images/gm_03.png';
import gm_04 from '../assets/images/gm_04.jpg';
import gm_05 from '../assets/images/gm_05.png';
import gm_06 from '../assets/images/gm_06.jpg';
import gm_07 from '../assets/images/gm_07.png';

import vr_01 from '../assets/images/vr_01.png';
import vr_02 from '../assets/images/vr_02.png';
import vr_03 from '../assets/images/vr_03.png';
import vr_04 from '../assets/images/vr_04.png';
import vr_05 from '../assets/images/vr_05.png';

import ed_01 from '../assets/images/ed_01.png';
import ed_02 from '../assets/images/ed_02.png';
import ed_03 from '../assets/images/ed_03.png';
import ed_04 from '../assets/images/ed_04.png';

import sup_01 from '../assets/sup_01.webp';
import sup_02 from '../assets/sup_02.webp';
import sup_03 from '../assets/sup_03.webp';
import sup_04 from '../assets/sup_04.webp';

import sk_01 from '../assets/images/sk_01.mp4';
import sk_02 from '../assets/images/sk_02.mp4';
import sk_03 from '../assets/images/sk_03.mp4';
import sk_04 from '../assets/images/sk_04.mp4';

import pricetopbg from '../assets/X_Background.png';

const exportData = {
    youtube_icon,
    blog_icon,
    star_line,
    down_arrow,
    checked1,
    subject_img1,
    subject_img2,
    subject_img3,
    short1,
    short2,
    short3,
    light,
    learning,
    book,
    event_img1,
    event_img2,
    update_left,
    update_right,
    service_call,
    top_close,
    menu_line,
    pause,
    play,
    quick_login,
    quick_myclass,
    quick_mybook,
    quick_classbook,
    quick_up,
    quick_chat,
    quick_myclass_white,
    quick_mybook_white,
    quick_classbook_white,
    quick_up_white,
    quick_chat_white,
    arrow_right_white,
    arrow_left_white,
    x_icon_white,
    check_navy,
    move_top_arrow,
    quick_logout,
    service_btn_right,
    test_book,
    input_check,
    input_view,
    input_view_off,
    logo1,
    logo2,
    logo3,
    logo4,
    logo5,
    logo6,
    logo7,
    logo8,
    logo9,
    logo10,
    logo11,
    logo12,
    logo13,
    logo14,
    logo15,
    option_chk,
    test_img1,
    test_img2,
    test_img3,
    test_img4,
    test_img5,
    library_list1_img1,
    library_list1_img2,
    library_list1_img3,
    library_list1_img4,
    library_list1_img5,
    library_list2_img1,
    library_list2_img2,
    library_list2_img3,
    library_list2_img4,
    library_list2_img5,
    library_list3_img1,
    library_list3_img2,
    library_list3_img3,
    library_list3_img4,
    library_list3_img5,
    library_list4_img1,
    library_list4_img2,
    library_list4_img3,
    library_list4_img4,
    library_list4_img5,
    header_game_dev_img1,
    header_game_dev_img2,
    header_game_dev_img3,
    header_game_dev_img4,
    header_game_dev_img5,
    header_game_dev_img6,
    header_game_dev_img7,
    header_metaverse_img1,
    header_metaverse_img2,
    header_metaverse_img3,
    header_metaverse_img5,

    gm_01,
    gm_02,
    gm_03,
    gm_04,
    gm_05,
    gm_06,
    gm_07,

    vr_01,
    vr_02,
    vr_03,
    vr_04,
    vr_05,

    ed_01,
    ed_02,
    ed_03,
    ed_04,

    sup_01,
    sup_02,
    sup_03,
    sup_04,

    sk_01,
    sk_02,
    sk_03,
    sk_04,

    pricetopbg
}

export default exportData;